__turbopack_context__.v({
  "className": "IUynnG_className",
  "variable": "IUynnG_variable",
});
